import { gql, useMutation } from '@apollo/client';

import { ONBOARDING_FAMILY_FRAGMENT } from '../queries/useOnboardingState';

import type { LinkDependentsMutation, LinkDependentsMutationVariables } from './__generated__/useLinkDependents.gql';

const LINK_DEPENDENTS = gql`
  mutation LinkDependents($input: LinkDependantsInput!) {
    linkDependants(input: $input) {
      ...OnboardingFamilyFragment
    }
  }
  ${ONBOARDING_FAMILY_FRAGMENT}
`;

/**
 * Creates a `DependantPartnership` row between two dependents. Returns the
 * parent `Family` so Apollo's cache picks up the new partnership row on
 * the queries that observe `Family.dependantPartnerships` — no manual
 * refetch needed.
 */
export const useLinkDependents = () => {
  return useMutation<LinkDependentsMutation, LinkDependentsMutationVariables>(LINK_DEPENDENTS);
};
